






































// import { Assumption } from '@/data/fields'
import store from '../store'

export default {
  data () {
    return {
      title: 'Data Entry',
      fixedTabs: {
        position: 'fixed',
        top: '54px',
        zIndex: '2',
        width: '100%',
        left: '0'
      }
    }
  },

  created: function (this:any) {
    store.state.activeTab = 'calculator'
  },

  computed: {
    // Disable results tab
    disableResults() {
      if (
        store.state.scenarios.length < 1 ||
        store.state.selectedScenario === null
        // store.state.selectedScenario.value.assumptions.perennial.filter((a:Assumption) => (a.value === null || a.value === undefined || a.value === '')).length > 0 ||
        // store.state.selectedScenario.value.assumptions.shortTerm.filter((a:any) => (a.value === null || a.value === undefined || a.value === '')).length > 0 ||
        // store.state.selectedScenario.value.totals.perennial.all <= 0
        // store.state.selectedScenario.value.totals.shortTerm.all <= 0
      ) {
        return true
      }
      return false
    }
  },

  store
}
